/**
 *
 * Asynchronously loads the component for AssetDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.AssetDetailsPage,
);
